interface TasksCheckIconProps {
  /** Stroke color; white when selected, #999999 when inactive. */
  strokeColor?: string;
}

/**
 * Tick / check-mark icon for the Tasks navigation tab (matches the Figma
 * design). A plain stroke glyph like the other nav icons — no background.
 *
 * @param strokeColor - Icon stroke color (defaults to white for active state)
 */
const TasksCheckIcon = ({ strokeColor = "white" }: TasksCheckIconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M4 10.5L8.5 15L16 6"
        stroke={strokeColor}
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default TasksCheckIcon;
